import React, { PropTypes } from 'react';
import moment from 'moment';
import { isDate, groupBy } from 'lodash';
import Filter from '../Filter';

import { NitroPlaceholder, NitroDatePicker } from 'nitro-components';
import SingleSelect from '../single-select/SingleSelect';

import styled from 'styled-components';

const DatePickerContainer = styled.div`margin-bottom: 16px;`;

class DateRangeInsightsFilter extends Filter {
  static getLabel = filter => {
    const label = Filter.getLabel(filter);

    if (filter.type === 'custom') {
      const { start, end } = filter.value;

      const startString = moment(start).format('D MMM YYYY');
      const endString = moment(end).format('D MMM YYYY');
      return `${startString} - ${endString}`;
    }
    return label;
  };

  handleOptionSelect = option => {
    const { value, label, datetype } = option;
    this.props.action({
      type: value,
      label,
      value,
      datetype
    });
  };

  setStartDate = date => {
    const { filter } = this.props;
    const { value } = filter;

    const start = date;
    const end = value.end;
    const label = DateRangeInsightsFilter.getLabel({
      type: 'custom',
      value: { start, end }
    });
    this.props.action({ type: 'custom', label, value: { start, end } });
  };

  setEndDate = date => {
    const { filter } = this.props;
    const { value } = filter;

    const end = date;
    const start = value.start;
    const label = DateRangeInsightsFilter.getLabel({
      type: 'custom',
      value: { start, end }
    });
    this.props.action({ type: 'custom', label, value: { start, end } });
  };

  getDateObject = dateString => {
    return dateString ? new Date(dateString) : dateString;
  };

  getDateCustomizer(customDateValues) {
    const { start, end } = this.props.filter.value;
    const startDate = this.getDateObject(start);
    const endDate = this.getDateObject(end);
    const ruleType = customDateValues[0].rule.type;
    let now = new Date();
    let minDate = null;
    let maxDate = null;
    // Handle allowPast,allowFuture and allowAll scenario
    //in case of allow all setting a range of +/- 100 years
    switch (ruleType) {
      case 'allowPast':
        //default setting - allowing past dates
        break;
      case 'allowFuture':
        //set min date in case of future dates
        minDate = now;
        break;
      case 'allowAll':
        minDate = moment().subtract(100, 'years').toDate();
        break;
    }
    //in case rules - start and end date exist
    if (customDateValues[0].rule.startDate) {
      minDate = this.getDateObject(customDateValues[0].rule.startDate);
    }
    if (customDateValues[0].rule.endDate) {
      maxDate = this.getDateObject(customDateValues[0].rule.endDate);
    }

    let startDatePicker = null;
    if (endDate) {
      startDatePicker = (
        <NitroDatePicker
          placeholder="Start Date"
          value={startDate}
          onChange={this.setStartDate}
          maxDate={endDate}
          minDate={minDate ? minDate : null}
        />
      );
    } else {
      startDatePicker = (
        <NitroDatePicker
          placeholder="Start Date"
          value={startDate}
          onChange={this.setStartDate}
          maxDate={!minDate ? now : maxDate}
          minDate={minDate}
        />
      );
    }

    let endDatePicker = null;
    if (startDate) {
      endDatePicker = (
        <NitroDatePicker
          placeholder="End Date"
          value={endDate}
          minDate={startDate}
          maxDate={!minDate ? now : maxDate}
          onChange={this.setEndDate}
        />
      );
    } else {
      endDatePicker = (
        <NitroDatePicker
          placeholder="End Date"
          value={endDate}
          maxDate={!minDate ? now : maxDate}
          minDate={minDate ? minDate : null}
          onChange={this.setEndDate}
          fullWidth
        />
      );
    }

    return (
      <section>
        <NitroPlaceholder size={10} />
        <DatePickerContainer>
          {startDatePicker}
        </DatePickerContainer>
        <DatePickerContainer>
          {endDatePicker}
        </DatePickerContainer>
      </section>
    );
  }

  render() {
    const { filter } = this.props;
    const { type, options, datetype, value } = filter;

    let optionsGrouped = groupBy(options, function(item) {
      return item.type;
    });

    const standardDateValues = optionsGrouped.standard || [];
    const customDateValues = optionsGrouped.custom || [];
    customDateValues.length ? (customDateValues[0].value = 'custom') : '';

    const selectFilter = {
      value: type === 'custom' ? 'custom' : value,
      options: [...standardDateValues, ...customDateValues],
      datetype: datetype
    };

    return (
      <section>
        <SingleSelect filter={selectFilter} action={this.handleOptionSelect} />
        {type === 'custom' ? this.getDateCustomizer(customDateValues) : null}
      </section>
    );
  }
}

DateRangeInsightsFilter.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired
};

export default DateRangeInsightsFilter;



// WEBPACK FOOTER //
// ./src/components/filter/filters/date-range/DateRangeInsightsFilter.js